$(function () {
    $('input, textarea').on('focus', function () {
        $('.js-gaiji-button').removeClass('fixed-bottom').addClass('fixed-top')
    }).on('blur', function () {
        setTimeout(function () {
            $('.js-gaiji-button').removeClass('fixed-top').addClass('fixed-bottom')
        }, 100)
    })
})